import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useState } from "react";
import { Field, Form, Formik, FormikHelpers } from "formik";
import axios from "axios";
import { FormButton } from "../Register/RegisterStyles";
import { Loader } from "../../../components/Loader/Loader";
import { ArticleBlock, FormMainBlock } from "../FormsGeneralStyles";
import { useAppSelector } from "../../../store/hooks";
import { ResetPasswordFormValues } from "../../../interfaces/ResetPasswordInterface";
import { useNavigate, useSearchParams } from "react-router-dom";

export const ResetPassword = () => {
  const [isSuccess, setSuccess] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const { t } = useTranslation();
  const lang = useAppSelector((state) => state.locale.localStorageValue);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const emailFromUrl = searchParams.get("email") || "";
  const tokenFromUrl = searchParams.get("token") || "";

  const handleResetSubmit = async (
    values: ResetPasswordFormValues,
    formikHelpers: FormikHelpers<ResetPasswordFormValues>
  ) => {
    setInProgress(true);
    setSuccess(false);

    try {
      const response = await axios.post(
        "https://api.test-client-74445.biz/auth/reset/",
        {
          email: values.email,
          password: values.password,
          password_confirmation: values.password_confirmation,
          token: values.token,
        },
        {
          headers: {
            "Accept": "application/json",
            "Accept-Language": lang,
          },
        }
      );

      setSuccess(true);

      if (lang === "en") {
        navigate("/auth/reset-password-ok");
      } else {
        navigate(`/${lang}/auth/reset-password-ok`);
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        console.error("Server error:", error.response.data);
      } else {
        console.error("Unexpected error:", error);
      }
      setSuccess(false);
      // if (axios.isAxiosError(error) && error.response) {
      //   const { status, data } = error.response;

      //   if (status === 422 && data.errors) {
      //     Object.keys(data.errors).forEach((field) => {
      //       formikHelpers.setFieldError(field, data.errors[field]);
      //     });
      //   }

      //   if (status === 401) {
      //     setErrorMessage(t("formsWarnings.tokenExpired"));
      //   }
      // } else {
      //   setErrorMessage(t("formsWarnings.unexpectedError"));
      // }
    } finally {
      setInProgress(false);
    }
  };

  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, t("formsWarnings.tooShort"))
      .required(t("formsWarnings.passwordRequired")),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password")], t("formsWarnings.passwordDoNotMatch"))
      .required(t("formsWarnings.passwordRequired")),
  });

  return (
    <main>
      <FormMainBlock>
        <section>
          <div className="container__standart div__container">
            <div className="div__form">
              <h3>{t("resetPasswordPage.title1")}</h3>
              <Formik
                initialValues={{
                  email: emailFromUrl,
                  password: "",
                  password_confirmation: "",
                  token: tokenFromUrl,
                }}
                validationSchema={ResetPasswordSchema}
                onSubmit={handleResetSubmit}
              >
                {({ errors, touched }) => (
                  <Form className="form__content">
                    <ArticleBlock>
                      <div className="div__main__block">
                        <Field
                          id="password"
                          name="password"
                          placeholder={t("form.password")}
                          type="password"
                          className={`input__styles ${
                            touched.password &&
                            errors.password &&
                            "!border-[#eb5757]"
                          }`}
                        />
                        {touched.password && errors.password && (
                          <span className="form__req__info">
                            {errors.password}
                          </span>
                        )}
                      </div>
                    </ArticleBlock>
                    <ArticleBlock>
                      <div className="div__main__block">
                        <Field
                          id="password_confirmation"
                          name="password_confirmation"
                          placeholder={t("form.repeatPassword")}
                          type="password"
                          className={`input__styles ${
                            touched.password_confirmation &&
                            errors.password_confirmation &&
                            "!border-[#eb5757]"
                          }`}
                        />
                        {touched.password_confirmation &&
                          errors.password_confirmation && (
                            <span className="form__req__info">
                              {errors.password_confirmation}
                            </span>
                          )}
                      </div>
                    </ArticleBlock>
                    <div>
                      {inProgress ? (
                        <Loader height="41" width="100%" />
                      ) : (
                        <FormButton
                          type="submit"
                          className="white__button flex__center log__btn"
                          style={{ marginTop: "50px" }}
                        >
                          {isSuccess
                            ? t("form.successfully")
                            : t("form.restore")}
                        </FormButton>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </section>
      </FormMainBlock>
    </main>
  );
};
